export default __webpack_public_path__ + "static/media/investors.a337bf8d.wav";